import TextInputEx from "components/_extensions/react-admin/input/TextInputEx";
import { CompanySelect } from "components/inputs";
import { NumberInputEx } from "components/inputs";
import { SelectEnumInput } from "components/inputs/SelectEnumInput";
import { DeviationMainCategory } from "entities/DeviationMainCategory";
import { DeviationStatus } from "entities/DeviationStatus";
import { DeviationType, DeviationTypeByMainCategory } from "entities/DeviationType";
import React from "react";
import { AutocompleteInput, Filter, ReferenceInput } from "react-admin";

import { ToggleDatesEnum, ToggleDatesFilter } from "../../../components/filters/ToggleDatesFilter";
import { ToggleStateFilter } from "../../../components/filters/ToggleStateFilter";
import { envSettings } from "core/EnvSettings";
const REACT_APP_4_HOURS_AHEAD_FILTER__HIDDEN =
	envSettings.REACT_APP_4_HOURS_AHEAD_FILTER__HIDDEN;

export const DeviationsFilter = (props) => {
	return (
		<Filter {...props}>
			<ToggleDatesFilter
				source="named_created_at"
				hiddenButtons={{
					[ToggleDatesEnum.FOUR_HOURS_AHEAD]: REACT_APP_4_HOURS_AHEAD_FILTER__HIDDEN,
				}}
				alwaysOn
			/>
			<ToggleStateFilter
				source="status_state"
				alwaysOn
				key={"status_state"}
			/>
			<CompanySelect source="company_id" allowEmpty={false} resettable key={"company_id"} />
			<ReferenceInput source="created_by" reference="users" resettable key={"created_by"} perPage={15} filter={{ no_range: false }}>
				<AutocompleteInput
					optionText={(record) =>
						record && record.first_name && record.last_name
							? `${record.first_name} ${record.last_name}`
							: ""
					}
					resettable
				/>
			</ReferenceInput>
			<SelectEnumInput
				source="deviation_main_category"
				enumName="deviation_main_category"
				enumObj={DeviationMainCategory}
			/>
			<SelectEnumInput
				source="deviation_type"
				enumName="deviation_type"
				enumObj={DeviationTypeByMainCategory[props.filterValues?.deviation_main_category] || DeviationType}
			/>
			<NumberInputEx debounceTime={750} source="order_id" />
			<TextInputEx debounceTime={750} source="order_reference" />
			<SelectEnumInput source="status" enumName="deviation_status" enumObj={DeviationStatus} />
		</Filter>
	);
};
